<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                 style="min-height: 400px; background-image: url(/img/cars/morning2.jpg); background-size: cover; background-position: center top;">
        <!-- Mask -->
        <span class="mask bg-dark opacity-8"></span>
        <!-- Header container -->
        <div class="container-fluid d-flex align-items-center">
            <div class="row">
                <div class="col-lg-7 col-md-10">
                    <h1 class="display-2 text-white">Check Any Model</h1>
                    <p class="text-white mt-0 mb-5">Enter values in the various boxes and click on do the maths to get a detailed statistic of the kehillah model in itys glory and ascertain whether it makes sense to invest</p>
                </div>
            </div>
        </div>
    </base-header>
    <div class="container-fluid mt--7">
        <div class="row">

        <div class="col-xl-12 order-xl-1">
          <paystack
              :amount="amount"
              :email="email"
              :paystackkey="paystackkey"
              :reference="reference"
              :callback="callback"
              :close="close"
              :embed="false"
              currency="GHS"
              :channels = "['mobile_money', 'card']"
          >
             <i class="fas fa-money-bill-alt"></i>
             Make Payment
          </paystack>

        </div>
      </div>
    </div>

  </div>

</template>

<script type="text/javascript">
import paystack from 'vue-paystack';
export default {
    components: {
        paystack
    },
    data(){
        return{
          paystackkey: "pk_live_d6a4acbe461b906408b88c5e8a483743d9450d9f", //paystack public key
          email: "charles.kehillah@gmail.com", // Customer email
          amount: 400 // in kobo
        }
    },
    computed: {
      reference(){
        let text = "";
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for( let i=0; i < 10; i++ )
          text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
      }
    },
    methods: {
      callback (response){
        console.log(response)
      },
      close (){
          console.log("Payment closed")
      }
    }
}
</script>
